<script lang="ts">
	import NavbarContainer from './NavbarContainer.svelte';

	let y: number;
	let navClass = `h-[95px] navbar z-20 top-0 left-0 text-gray-100 fixed w-full`;
</script>

{#if y > 0}
	<div class="{navClass} bg-opacity-90 bg-cosmicPurple800 shadow-lg max-w-full">
		<NavbarContainer />
	</div>
{:else}
	<div class={navClass}>
		<NavbarContainer />
	</div>
{/if}
<svelte:window bind:scrollY={y} />
<slot />
